import { InjectionToken } from '@angular/core';
import { Tracker } from './tracker.interface';

// Add additional provider entry in app.module, to get future services e.g. googleanalytics
export const TRACKER_TOKEN = new InjectionToken<Tracker[]>('TRACKER_TOKEN');